__turbopack_context__.v({
  "search_landing__content": "SearchLanding-module-scss-module__wj3UPW__search_landing__content",
  "search_landing__filters": "SearchLanding-module-scss-module__wj3UPW__search_landing__filters",
  "search_landing__loading": "SearchLanding-module-scss-module__wj3UPW__search_landing__loading",
  "search_landing__results": "SearchLanding-module-scss-module__wj3UPW__search_landing__results",
});
